  <div class="radial-chart-container">
    <!-- Chart -->
    <div class="chart-container">
      <canvas #masterChart></canvas>
    </div>
  
    <!-- Custom Legend -->
    <div class="chart-labels">
      <ul>
        <li *ngFor="let label of chartDetails.data.labels; let i = index">
          <span
            class="color-box"
            [ngStyle]="{
              backgroundColor: chartDetails.data.datasets[i].backgroundColor[0]
            }"
          ></span>
          {{ label }}: {{ chartDetails.data.datasets[i].data[0] }}%
        </li>
      </ul>
    </div>
  </div>